import React from 'react';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import { IInactiveFilterButtonProps } from '../types';
import { FilterIconFilled } from '@navi/web-ui/lib/icons';

const InactiveFilterButton: React.FC<IInactiveFilterButtonProps> = ({
  onOpenDrawer,
  isDisabled = false
}) => (
  <Button
    variant="secondary"
    onClick={onOpenDrawer}
    disabled={isDisabled}
    className="!opacity-100"
    startAdornment={
      <FilterIconFilled color="var(--blue-base)" className={isDisabled ? 'opacity-70' : ''} />
    }
  >
    <Typography
      variant="h4"
      color="var(--navi-color-gray-c2)"
      className={isDisabled ? 'opacity-70' : ''}
    >
      Filters
    </Typography>
  </Button>
);

export default InactiveFilterButton;
